import * as SalesActions from './sales';
import * as SalesDetailActions from './salesDetail';
import * as StockActions from './stock';

const Actions = {
  ...SalesActions,
  ...SalesDetailActions,
  ...StockActions,
};

export default Actions;
